import { AsyncSelectForm, AsyncSelectOption } from '@/components/forms/AsyncSelectForm';
import { getOriginDestiny } from '@/api/originDestinyAPI';
import { UseControllerProps } from 'react-hook-form';

export interface ISelectFormData {
  id: string | number;
  title: string;
  subtitle?: string;
}

interface Props {
  name: string;
  label?: string;
  control: any;
  rules?: any;
  defaultValue?: any;
  notFoundMessage?: string;
  placeholder?: string;
  disabled?: boolean;
}

const fetchOriginDestiny = async (search: string): Promise<AsyncSelectOption[]> => {
  const response = await getOriginDestiny({ page: 1, per_page: 10, search });
  if (!Array.isArray(response)) return [];
  return response.map(({ id, name, description }) => ({
    id,
    label: name,
    subtitle: description && description !== name ? description : undefined,
  }));
};

export function SelectFormOriginDestiny(props: Props & UseControllerProps) {
  return (
    <AsyncSelectForm
      {...props}
      fetcher={fetchOriginDestiny}
      notFoundMessage={props.notFoundMessage ?? 'No se encontraron lugares de origen/destino.'}
      placeholder={props.placeholder ?? 'Buscar origen/destino...'}
    />
  );
}
